import {inject} from '@angular/core'
import {Router} from '@angular/router'
import {from, Observable, of} from 'rxjs'
import {ConfigService} from '../services/config.service'

export const routeResolver = (
  service: ConfigService,
  router: Router,
  window: Window
): Observable<boolean> => {
  const location = window.location

  const onInternalRoute = location.hostname.includes('internal')

  service.onSparaRoute = !onInternalRoute
  service.onInternalRoute.set(onInternalRoute)

  if (onInternalRoute) {
    return from(router.navigate(['/admin']))
  }

  return of(true)
}

export const internetbankenResolver = () => {
  const service = inject(ConfigService)
  service.onInternetBankRoute.set(true)
}

